var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGotop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 84,
    viewBox: "0 0 86 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(456 -260) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(260 376)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 37.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(272 370)",
    fill: "#fcee21"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(260 376)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 37.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.682,26.1,1.1,16.078a3.415,3.415,0,0,1,0-5.013L11.682,1.039a3.892,3.892,0,0,1,5.293,0,3.413,3.413,0,0,1,0,5.013l-7.94,7.52,7.94,7.52a3.413,3.413,0,0,1,0,5.013,3.892,3.892,0,0,1-5.293,0Z",
    transform: "translate(291 400.429)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotop);
export default __webpack_public_path__ + "static/media/gotop.eb0418619c7e3402bd579c0f9f8c50cf.svg";
export { ForwardRef as ReactComponent };